export default __webpack_public_path__ + "static/media/table_cancer_PC_Hk.ec2f8454.webp";